import { Route } from "react-router-dom";
import Footer from "../components/layout/footer";
import Header from "../components/layout/header";
import HomePage from "../pages/home";
import ContactPage from "../pages/static/contact";
import AboutPage from "../pages/static/about";
import CorporateGovernancePage from "../pages/corporate/governance";
import { LoanApplicationPage } from "../pages/loan-application";
import { VerificationPage } from "../pages/verification";
import IdentityVerificationPage from "../pages/identity-verification";
import PhoneVerificationPage from "../pages/phone-verification";
import CaptchaGuard from "../components/guard/CaptchaGuard";

function MainRouter() {
  return (
      <>
        <Header />
        <Route path={["/home", "/"]} exact component={HomePage} />
        <Route path={"/corporate-governance"} exact component={CorporateGovernancePage} />
        <Route path="/about" exact component={AboutPage} />
        <Route path="/contact" exact component={ContactPage} />
        <Route path="/loan" exact>
          <VerificationPage/>
        </Route>
        <Route path="/identity-verification" exact>
          <IdentityVerificationPage />
        </Route>
        <Route path="/phone-verification" exact>
          <PhoneVerificationPage />
        </Route>
        <Route path="/loan-application" exact>
          <CaptchaGuard>
            <LoanApplicationPage />
          </CaptchaGuard>
        </Route>
        <Footer />
      </>
  )
}

export default MainRouter;